import * as React from "react";
import { useTranslation } from "./i18n";
var AutoPlayButton = function (props) {
    var onSubmit = props.onSubmit, canSubmit = props.canSubmit, isCurrentPlayerTurn = props.isCurrentPlayerTurn, playDescription = props.playDescription, currentWinner = props.currentWinner, unsetAutoPlayWhenWinnerChanges = props.unsetAutoPlayWhenWinnerChanges;
    var t = useTranslation().t;
    var _a = React.useState(null), autoplay = _a[0], setAutoplay = _a[1];
    React.useEffect(function () {
        if (autoplay !== null) {
            if (!canSubmit) {
                setAutoplay(null);
            }
            else if (unsetAutoPlayWhenWinnerChanges &&
                autoplay.observedWinner !== currentWinner) {
                setAutoplay(null);
            }
            else if (isCurrentPlayerTurn) {
                setAutoplay(null);
                onSubmit();
            }
        }
    }, [
        autoplay,
        canSubmit,
        currentWinner,
        isCurrentPlayerTurn,
        unsetAutoPlayWhenWinnerChanges,
    ]);
    var handleClick = function () {
        if (isCurrentPlayerTurn) {
            onSubmit();
        }
        else if (autoplay !== null) {
            setAutoplay(null);
        }
        else {
            setAutoplay({ observedWinner: currentWinner });
        }
    };
    return (React.createElement("button", { className: "sj-btn " + (isCurrentPlayerTurn && canSubmit ? "sj-btn-primary" : ""), onClick: handleClick, disabled: !canSubmit }, isCurrentPlayerTurn
        ? "".concat(t("play.playSelected")).concat(playDescription !== null ? " (" + playDescription + ")" : "")
        : autoplay !== null
            ? t("play.cancelAutoplay")
            : t("play.autoplay")));
};
export default AutoPlayButton;
